import React from 'react';
import { Outlet, useNavigate, useLocation } from 'react-router-dom';
import Sidebar from './Sidebar';
import TopBar from './TopBar';
import { useAuth } from '../../hooks/useAuth.jsx';

const MainLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { user, logout: authLogout } = useAuth();

  // Determine user type from user role
  const userRole = user?.role;
  const effectiveUserType = userRole === 'Artisan' ? 'artisan' : 'customer';

  const handleLogout = async () => {
    try {
      await authLogout();
      navigate('/');
    } catch (error) {
      // Fallback: force redirect even if logout fails
      navigate('/');
    }
  };

  return (
    <div className="flex h-screen bg-gray-50">
      {/* Sidebar */}
      <Sidebar userType={effectiveUserType} />

      {/* Main Content */}
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Top Bar */}
        <TopBar logout={handleLogout} userType={effectiveUserType} userData={user} />

        {/* Main Content Area */}
        <main className="flex-1 overflow-y-auto p-4 pb-28 lg:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
